/* ================= Device model and shared variables ================= */
var device=new THREE.Group();
scene.add(device);
var B=-0.43; // rear z

// Global references for external raycasting and direct rotation controls.
var wheelG, donutPivot, donut, centerBtn;

// —— Body with rounded corners and bevels; flat front plane at Z = 0.430 ——
var bodyGeo=new THREE.ExtrudeGeometry(roundedRect(3.5,7.4,0.85),
  {depth:0.5,bevelEnabled:true,bevelThickness:0.18,bevelSize:0.18,bevelSegments:7,curveSegments:48});
bodyGeo.translate(0,0,-0.25);
var body=new THREE.Mesh(bodyGeo,matBody);
body.castShadow=true;
device.add(body);

// —— Front: screen ——
var screenCenterY=1.95;
var frame=new THREE.Mesh(new THREE.ShapeGeometry(roundedRect(3.04,3.04,0.62),48),matFrame);
frame.position.set(0,screenCenterY,0.434);
device.add(frame);

var screenSize=2.95;
var screenGeo=new THREE.ShapeGeometry(roundedRect(screenSize,screenSize,0.575),48);
var screenGeoPosition=screenGeo.getAttribute('position');
var screenGeoUv=screenGeo.getAttribute('uv');
for(var screenVertexIndex=0;screenVertexIndex<screenGeoPosition.count;screenVertexIndex++){
  screenGeoUv.setXY(
    screenVertexIndex,
    screenGeoPosition.getX(screenVertexIndex)/screenSize+0.5,
    screenGeoPosition.getY(screenVertexIndex)/screenSize+0.5
  );
}
screenGeoUv.needsUpdate=true;
var screen=new THREE.Mesh(screenGeo,
  new THREE.MeshBasicMaterial({map:screenTex,transparent:true,toneMapped:false}));
screen.position.set(0,screenCenterY,0.438);
device.add(screen);

// Raised black silicone bumper around the glass. Its inner and outer curves
// share the upper shell corner centers and keep the screen raycast target clear.
var screenBumperShape=roundedRect(3.09,3.09,0.645);
var screenBumperInnerPoints=roundedRect(2.92,2.92,0.56).getPoints(96).reverse();
var screenBumperHole=new THREE.Path();
screenBumperHole.moveTo(screenBumperInnerPoints[0].x,screenBumperInnerPoints[0].y);
for(var screenBumperPointIndex=1;screenBumperPointIndex<screenBumperInnerPoints.length;screenBumperPointIndex++){
  screenBumperHole.lineTo(
    screenBumperInnerPoints[screenBumperPointIndex].x,
    screenBumperInnerPoints[screenBumperPointIndex].y
  );
}
screenBumperHole.closePath();
screenBumperShape.holes.push(screenBumperHole);

var screenBumperGeo=new THREE.ExtrudeGeometry(screenBumperShape,{
  depth:0.044,
  bevelEnabled:true,
  bevelThickness:0.012,
  bevelSize:0.014,
  bevelSegments:4,
  curveSegments:48,
  steps:1
});
var screenBumper=new THREE.Mesh(screenBumperGeo,matSilicone);
screenBumper.name='screen-silicone-bumper';
screenBumper.position.set(0,screenCenterY,0.439);
screenBumper.castShadow=true;
device.add(screenBumper);

// —— Front: silver 3D wheel group with clear seams and physical drag rotation ——
wheelG=new THREE.Group(); wheelG.position.set(0,-1.7,0); device.add(wheelG);
var repodWheelReceivesShadow = !repodIsCoarsePointerDevice();

// 1. Dark recessed base disc, just above the front surface, acting as the physical shadow edge in the wheel gaps.
var wheelWell = new THREE.Mesh(
  new THREE.CircleGeometry(1.46, 96),
  new THREE.MeshStandardMaterial({
    color: 0x1d1f22,            
    roughness: 0.7,
    metalness: 0.2
  })
);
wheelWell.position.z = 0.4306;
wheelWell.castShadow = false;
wheelWell.receiveShadow = false;
wheelG.add(wheelWell);

// 2. Dedicated wheel-spin pivot at Z = 0.433, isolating self-rotation to avoid Euler rotation lockups.
donutPivot = new THREE.Group();
donutPivot.position.z = 0.433;
wheelG.add(donutPivot);

// 3. Rounded 3D wheel profile, built for anodized-silver highlights.
var wheelPts=[];
(function(){
  var r0=0.58;       
  var r1=1.425;      
  var bump=0.155;    
  var N=40;
  for(var i=0; i<=N; i++){
    var t=i/N;
    var r=r0+(r1-r0)*t;
    var z=bump*Math.pow(Math.sin(t*Math.PI), 1.25);
    wheelPts.push(new THREE.Vector2(r, z));
  }
})();
donut=new THREE.Mesh(new THREE.LatheGeometry(wheelPts,96), matWheel);
donut.rotation.x=Math.PI/2; 
donut.castShadow=true; 
donut.receiveShadow=repodWheelReceivesShadow;
donutPivot.add(donut);          

// 4. Separate rounded 3D center button at the highest front layer.
var btnPts=[];
(function(){
  var br1=0.52;      
  var bump=0.082;    
  var N=30;
  for(var i=0; i<=N; i++){
    var t=i/N;       
    var r=br1*(1.0 - t);
    var z=bump*(1.0 - Math.pow(1.0 - t, 3.5)); 
    btnPts.push(new THREE.Vector2(r, z));
  }
})();
centerBtn=new THREE.Mesh(new THREE.LatheGeometry(btnPts,64), matWheel);
centerBtn.rotation.x=Math.PI/2;
centerBtn.position.z=0.436;     
centerBtn.castShadow=true;
centerBtn.receiveShadow=repodWheelReceivesShadow;
wheelG.add(centerBtn);

// —— Visible wheel feedback: soft rotating light and shadow projected onto the body ——
// The wheel surface stays clean; motion appears through its shadow rotating across the body.
var shadowRing=(function(){
  var IN=1.40, OUT=1.70;                    // inner / outer shadow radii in world units, landing on the flat front body area
  var S=512, C=S/2, outPx=250, scale=outPx/OUT, inPx=IN*scale;
  var c=document.createElement('canvas'); c.width=S; c.height=S;
  var x=c.getContext('2d');
  var img=x.createImageData(S,S), d=img.data;
  for(var py=0;py<S;py++)for(var px=0;px<S;px++){
    var ddx=px-C+0.5, ddy=py-C+0.5;
    var r=Math.hypot(ddx,ddy), a=0;
    if(r<=outPx){
      var ft=clamp((r-inPx)/(outPx-inPx),0,1);
      var radial=Math.pow(1-ft,1.35);                             // soft falloff outward from the wheel edge
      var ang=Math.atan2(ddy,ddx);
      var w=0.46+0.22*Math.sin(2*ang)+0.16*Math.sin(ang+1.2);     // smooth light and dark lobes for seamless rotation
      a=clamp(radial*w,0,1)*255;
    }
    var i=(py*S+px)*4;
    d[i]=d[i+1]=d[i+2]=a; d[i+3]=255;
  }
  x.putImageData(img,0,0);
  var tex=new THREE.CanvasTexture(c);
  var m=new THREE.Mesh(
    new THREE.RingGeometry(IN,OUT,96),
    new THREE.MeshBasicMaterial({color:0x000000,alphaMap:tex,transparent:true,opacity:0.38,depthWrite:false})
  );
  m.position.z=-0.00065;   // keep the translucent shadow off the recessed disc to avoid mobile depth artifacts
  donutPivot.add(m);       // rotates with the wheel
  return m;
})();

// —— Left side: physical button details with red-orange controls and a coaxial dark metal port ——
var leftG = new THREE.Group();
device.add(leftG);

// 1. Red-orange pill button at the top
var sideBtn1=capsule(0.10,0.58,matOrange); 
sideBtn1.position.set(-1.95,2.25,0); 
leftG.add(sideBtn1);

// 2. Red-orange circular button in the middle
var sideBtn2 = new THREE.Mesh(new THREE.CylinderGeometry(0.11, 0.11, 0.12, 24), matOrange);
sideBtn2.rotation.z = Math.PI / 2;
sideBtn2.position.set(-1.95, 1.25, 0);
leftG.add(sideBtn2);

// 3. Deep black lower sensor / jack hole with bezel
var jackRim = new THREE.Mesh(new THREE.CylinderGeometry(0.11, 0.11, 0.08, 24), matSilver);
jackRim.rotation.z = Math.PI / 2;
jackRim.position.set(-1.92, 0.35, 0);
leftG.add(jackRim);

var jackInner = new THREE.Mesh(new THREE.CylinderGeometry(0.075, 0.075, 0.09, 24), new THREE.MeshStandardMaterial({color: 0x111112, roughness: 0.85, metalness: 0.1}));
jackInner.rotation.z = Math.PI / 2;
jackInner.position.set(-1.90, 0.35, 0);
leftG.add(jackInner);


// —— Right side: seven evenly spaced sound holes ——
var soundHolesG = new THREE.Group();

var rimGeo = new THREE.TorusGeometry(0.054, 0.016, 12, 24);
var depthGeo = new THREE.CylinderGeometry(0.038, 0.038, 0.01, 16); 
var matHoleDepth = new THREE.MeshStandardMaterial({ 
  color: 0x0a0a0c, 
  roughness: 0.95, 
  metalness: 0.05 
});

for (var i = 0; i < 7; i++) {
  var yPos = 0.72 + i * 0.18;
  var holeGroup = new THREE.Group();
  holeGroup.position.set(1.922, yPos, 0); 
  
  // 1. Metal rim
  var rimMesh = new THREE.Mesh(rimGeo, matSilver);
  rimMesh.rotation.y = Math.PI / 2;
  rimMesh.castShadow = true;
  rimMesh.receiveShadow = true;
  holeGroup.add(rimMesh);
  
  // 2. Dark hole base
  var depthMesh = new THREE.Mesh(depthGeo, matHoleDepth);
  depthMesh.rotation.z = Math.PI / 2;
  depthMesh.position.x = 0.004; 
  holeGroup.add(depthMesh);
  
  soundHolesG.add(holeGroup);
}
device.add(soundHolesG);


// —— Back: upper decorative rubber pads ——
[-0.33,0.33].forEach(function(sx){
  var s=pillMesh(0.57,0.14,0.014,matDark);
  s.position.set(sx,3.09,B-0.009); device.add(s);
});

// —— Back: circular opening exposing the Apple Watch sensor back ——
var wb=new THREE.Group(); wb.position.set(0,1.66,0); device.add(wb);
// Metal rim around the shell opening
var wbRing=new THREE.Mesh(new THREE.CylinderGeometry(1.08,1.08,0.09,72),matSilver);
wbRing.rotation.x=Math.PI/2; wbRing.position.z=B-0.005; wbRing.castShadow=true; wb.add(wbRing);
// Watch-back base
var wbBase=new THREE.Mesh(new THREE.CylinderGeometry(0.93,0.93,0.07,64),matBlackG);
wbBase.rotation.x=Math.PI/2; wbBase.position.z=B-0.010; wb.add(wbBase);
// Raised ceramic / glass dome
var dome=new THREE.Mesh(new THREE.SphereGeometry(0.90,48,32),matCrystal);
dome.scale.set(1,1,0.06); dome.position.z=-0.46; wb.add(dome);
// Etched ring on the dome
var domeRing=new THREE.Mesh(new THREE.RingGeometry(0.60,0.63,56),matLens);
domeRing.rotation.y=Math.PI; domeRing.position.z=-0.512; wb.add(domeRing);
// Heart-rate / blood-oxygen sensor array
var navy=new THREE.Mesh(new THREE.CylinderGeometry(0.52,0.52,0.012,48),matNavy);
navy.rotation.x=Math.PI/2; navy.position.z=-0.516; wb.add(navy);
var lens=new THREE.Mesh(new THREE.CylinderGeometry(0.215,0.215,0.012,36),matLens);
lens.rotation.x=Math.PI/2; lens.position.z=-0.522; wb.add(lens);
var hl=new THREE.Mesh(new THREE.CylinderGeometry(0.045,0.045,0.006,16),matBlueHL);
hl.rotation.x=Math.PI/2; hl.position.set(-0.09,0.09,-0.528); wb.add(hl);
[[0,0.30],[0,-0.30],[0.30,0],[-0.30,0]].forEach(function(p){
  var d=new THREE.Mesh(new THREE.CylinderGeometry(0.05,0.05,0.012,16),matDot);
  d.rotation.x=Math.PI/2; d.position.set(p[0],p[1],-0.520); wb.add(d);
});
// Small dot on the watch back
var extraDot=new THREE.Mesh(new THREE.CylinderGeometry(0.045,0.045,0.012,16),matDot);
extraDot.rotation.x=Math.PI/2; extraDot.position.set(0.12,-0.64,-0.500); wb.add(extraDot);

// —— Back: lower decorative rubber pads ——
[-0.33,0.33].forEach(function(sx){
  var s=pillMesh(0.57,0.14,0.014,matDark);
  s.position.set(sx,0.37,B-0.009); device.add(s);
});

// —— Back: seam lines ——
[[-1.100,1.300],[1.100,1.300]].forEach(function(sg){
  var seam=new THREE.Mesh(new THREE.BoxGeometry(sg[1],0.018,0.006),matSeam);
  seam.position.set(sg[0],-0.27,B-0.003); device.add(seam);
});

// —— Back: latch mechanism ——
var latch=new THREE.Group(); latch.position.set(0,-0.69,0); device.add(latch);
function latchShape(r,cut){
  var s=new THREE.Shape();
  var a=Math.asin(cut/r);              
  s.absarc(0,0,r,Math.PI-a,a,false);   
  s.closePath();                       
  return s;
}
var seatBase=new THREE.Mesh(new THREE.CircleGeometry(0.615,64),matRecess);
seatBase.rotation.y=Math.PI; seatBase.position.z=B-0.004; latch.add(seatBase);
var seatOutline=new THREE.Mesh(new THREE.RingGeometry(0.608,0.628,72),matSeam);
seatOutline.rotation.y=Math.PI; seatOutline.position.z=B-0.006; latch.add(seatOutline);

var latchRotor=new THREE.Group(); latch.add(lotor=latchRotor);
var latchGeo=new THREE.ExtrudeGeometry(latchShape(0.555,0.385),
  {depth:0.012,bevelEnabled:true,bevelThickness:0.035,bevelSize:0.035,bevelSegments:4,curveSegments:48});
latchGeo.translate(0,0,-0.006);
var latchDisc=new THREE.Mesh(latchGeo,matSilver); 
latchDisc.position.z=B-0.034; latchRotor.add(latchDisc);
var slotRim=pillMesh(0.56,0.135,0.010,matSilver);
slotRim.position.z=-0.508; latchRotor.add(slotRim);
var slot=pillMesh(0.49,0.085,0.010,matGray);
slot.position.z=-0.512; latchRotor.add(slot);
var latchOpen=false, latchRot=Math.PI;
latchRotor.rotation.z=latchRot;

// —— Back: screws and lower notch ——
[-1.43,1.43].forEach(function(sx,i){
  var sc=new THREE.Mesh(new THREE.CylinderGeometry(0.075,0.075,0.03,24),matSilver);
  sc.rotation.x=Math.PI/2; sc.position.set(sx,-3.11,B-0.010); device.add(sc);
  var sl=new THREE.Mesh(new THREE.BoxGeometry(0.11,0.016,0.006),matDark);
  sl.position.set(sx,-3.11,B-0.027); sl.rotation.z=i?-0.7:0.5; device.add(sl);
});
var notch=pillMesh(0.26,0.06,0.010,matDark);
notch.position.set(0,-3.72,B-0.006); device.add(notch);

/* ================= Ground shadow ================= */
var ground=new THREE.Mesh(new THREE.CircleGeometry(10,64),new THREE.ShadowMaterial({opacity:0.16}));
ground.rotation.x=-Math.PI/2; ground.position.y=-4.45; ground.receiveShadow=true;
// scene.add(ground);

/* ================= Magnetic charger demo ================= */
var charging=false, chargeT=0;
var charger=new THREE.Group();
charger.position.set(0,1.66,-3.0); 
charger.visible=false;
device.add(charger); 

var puck=new THREE.Mesh(new THREE.CylinderGeometry(0.82,0.82,0.12,56),matSilver); 
puck.rotation.x=Math.PI/2; puck.castShadow=true; charger.add(puck);
var puckFace=new THREE.Mesh(new THREE.CylinderGeometry(0.60,0.60,0.012,48),matWhite);
puckFace.rotation.x=Math.PI/2; puckFace.position.z=0.058; charger.add(puckFace);
var puckRim=new THREE.Mesh(new THREE.TorusGeometry(0.80,0.030,12,56),matSilver);
puckRim.position.z=0.045; charger.add(puckRim);
var cable=new THREE.Mesh(
  new THREE.TubeGeometry(new THREE.CatmullRomCurve3([
    new THREE.Vector3(0,0,-0.05),
    new THREE.Vector3(0,-0.15,-0.55),
    new THREE.Vector3(0,-0.90,-1.00),
    new THREE.Vector3(0,-2.40,-1.20)
  ]),32,0.045,12,false),matWhite);
charger.add(cable);
var glowMat=new THREE.MeshBasicMaterial({color:0x35e07a,transparent:true,opacity:0,side:THREE.DoubleSide});
var glow=new THREE.Mesh(new THREE.RingGeometry(0.84,0.97,56),glowMat);
glow.position.z=0.063; charger.add(glow);
var gLight=new THREE.PointLight(0x35e07a,0,3.5);
gLight.position.z=0.4; charger.add(gLight);
